import { startOfDay } from "date-fns";

import User from "@mapmycustomers/shared/types/User";

import { parseApiDate, parseApiDateWithTz } from "@app/util/parsers";

// The day boundary is computed in the org timezone (matching the event day groups / createdAtIsoDate),
// so the initially-selected day is the org-tz calendar day of the rep's latest location — the day every
// viewer lands on regardless of device timezone. The latest timestamp is still found via the true
// instant (parseApiDate); only the instant→calendar-day conversion uses the org tz.
const computeInitialSelectedDate = (
  selectedUsers: User[],
  orgTimeZone: string | undefined
): Date => {
  const candidateTimestamps = selectedUsers
    .map((user) => user.lastLocation?.createdAt)
    .filter((value): value is string => !!value)
    .map((isoString) => parseApiDate(isoString).getTime())
    .filter((ms) => Number.isFinite(ms));

  if (candidateTimestamps.length === 0) {
    return startOfDay(parseApiDateWithTz(new Date(), orgTimeZone));
  }

  return startOfDay(parseApiDateWithTz(new Date(Math.max(...candidateTimestamps)), orgTimeZone));
};

export default computeInitialSelectedDate;
